module.exports = __webpack_public_path__ + "static/media/3a.bbe925dc.png";